export default "__VITE_ASSET__Dz5JRZFY__"